import React, { useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import Button from '../components/ui/Button';
import { ArrowRightIcon, PlayIcon, XIcon } from 'lucide-react';
const VirtualTour = () => {
  const [activeVideo, setActiveVideo] = useState<string | null>(null);
  const tourSections = [{
    id: 'main-campus',
    title: 'Main Campus Tour',
    description: 'Explore our administrative building, classrooms, laboratories, library, and other academic facilities.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/de3EQh38fKgVchW9xJS4du/WhatsApp_Image_2025-10-24_at_10.01.26.jpg',
    videoId: 'main-campus-video'
  }, {
    id: 'academic',
    title: 'Academic Facilities',
    description: 'Explore our modern classrooms, science laboratories, computer labs, and library.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5gKYWryVTvwM3jPw4Bpnok/WhatsApp_Image_2025-10-24_at_10.01.16.jpg',
    videoId: 'academic-facilities-video'
  }, {
    id: 'boarding',
    title: 'Boarding Facilities',
    description: 'Take a tour of our dormitories, dining hall, and recreational areas for boarding students.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4jLMnmKXSAWwavqGR8zdhM/WhatsApp_Image_2025-10-24_at_11.30.13_%281%29.jpg',
    videoId: 'boarding-facilities-video'
  }, {
    id: 'sports',
    title: 'Sports Facilities',
    description: 'View our sports grounds, indoor facilities, and recreational areas.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8v7HegjxEmi2KSxNec1Zxz/WhatsApp_Image_2025-10-24_at_10.01.25.jpg',
    videoId: 'sports-facilities-video'
  }];
  return <div className="min-h-screen bg-white w-full" data-id="element-6077">
      <PageHeader title="Virtual Tour" description="Explore our beautiful campus and facilities from anywhere in the world." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/guWk5XsDGYmXXcoEtCyUpd/WhatsApp_Image_2025-10-24_at_11.30.12_%281%29.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Virtual Tour',
      path: '/virtual-tour'
    }]} data-id="element-6078" />
      <div className="container mx-auto px-4 py-12" data-id="element-6079">
        <div className="text-center mb-10" data-id="element-6080">
          <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6081">
            Welcome to Isonyin Grammar School
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6082"></div>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6083">
            Experience our campus through our photo gallery and explore our
            classrooms, laboratories, dormitories, sports facilities, and more.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-6084">
          <div className="relative rounded-lg overflow-hidden shadow-lg group h-96" data-id="element-6085">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/guWk5XsDGYmXXcoEtCyUpd/WhatsApp_Image_2025-10-24_at_11.30.12_%281%29.jpg" alt="School Campus Aerial View" className="w-full h-full object-cover" data-id="element-6086" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent flex items-end p-6" data-id="element-6087">
              <div className="text-white" data-id="element-6088">
                <h3 className="text-2xl font-bold mb-2" data-id="element-6089">Main Campus</h3>
                <p className="text-sm" data-id="element-6090">
                  Click on the sections below to explore different areas
                </p>
              </div>
            </div>
          </div>
          <div data-id="element-6091">
            <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-6092">
              Explore Our Campus
            </h3>
            <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-6093">
              Our main campus spans over 25 acres of beautifully landscaped
              grounds. Browse through our photo gallery to see our
              administrative building, classrooms, laboratories, library, and
              other academic facilities.
            </p>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-6094">
              Use the interactive sections below to explore specific areas of
              our campus and see what makes Isonyin Grammar School special.
            </p>
            <Button href="/gallery" variant="primary" icon={<ArrowRightIcon data-id="element-6096" />} iconPosition="right" data-id="element-6095">
              View Full Photo Gallery
            </Button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-6097">
          {tourSections.map(section => <div key={section.id} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden group" data-id="element-6098">
              <div className="relative h-48 overflow-hidden" data-id="element-6099">
                <img src={section.image} alt={section.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-6100" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-6101">
                  <div className="text-center text-white" data-id="element-6102">
                    <p className="text-sm font-medium" data-id="element-6103">View Photos</p>
                  </div>
                </div>
              </div>
              <div className="p-6" data-id="element-6104">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6105">
                  {section.title}
                </h3>
                <p className="text-gray-700 text-sm mb-4" data-id="element-6106">
                  {section.description}
                </p>
                <Button href="/gallery" variant="outline" size="sm" fullWidth data-id="element-6107">
                  View Photos
                </Button>
              </div>
            </div>)}
        </div>
        <div className="bg-blue-900 text-white p-8 rounded-lg mb-16" data-id="element-6108">
          <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-6109">
            <div className="mb-4 md:mb-0" data-id="element-6110">
              <h3 className="text-2xl font-bold mb-2" data-id="element-6111">Campus Map</h3>
              <p className="max-w-xl" data-id="element-6112">
                Download our campus map to navigate through different areas and
                learn more about each facility.
              </p>
            </div>
            <Button href="/contact" variant="primary" className="whitespace-nowrap" data-id="element-6113">
              Request Campus Map
            </Button>
          </div>
        </div>
        <div className="text-center" data-id="element-6114">
          <h2 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-6115">
            Want to Visit Us in Person?
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-6116">
            Nothing compares to experiencing our campus in person. Schedule a
            visit to meet our staff, interact with students, and get a feel for
            the Isonyin Grammar School community.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-6117">
            <Button href="/contact" variant="secondary" icon={<ArrowRightIcon data-id="element-6119" />} iconPosition="right" data-id="element-6118">
              Schedule a Visit
            </Button>
            <Button href="/admissions" variant="outline" data-id="element-6120">
              Apply for Admission
            </Button>
          </div>
        </div>
      </div>
    </div>;
};
export default VirtualTour;